
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React, { useEffect, useState } from 'react';
import axios from "axios";
import classNames from "classnames";
const CoinItem = ({ item, index, getDirection }) => {
    return <li className={classNames({
            "item": true,
            [`bg_${index}`]: true
        })}>
        <div className={'item_top'}>
            <div className={'item_main'}>
                <img className={''} 
    // src={`https://s2.coinmarketcap.com/static/img/coins/64x64/1.png`}
    src={`https://cryptofonts.com/img/SVG/${item.symbol.toLowerCase()}.svg`} alt={item.symbol}/>
                <div className="item_name">
                    <span className={'item_name_ticker'}>{item.symbol}</span>
                    <span className={'item_name_name'}>{item.name}</span>
                </div>
            </div>
            <div className={classNames({
            "item_label": true
        })}>HOT
            </div>
        </div>
        <div className={'item_bottom'}>
            <div className={'item_price'}>
                <span className={'item_price_price'}>{item.quotes.USD.price > 1 ? Number(item.quotes.USD.price).toFixed(2) : Number(item.quotes.USD.price).toFixed(6)}
                    <span className={'item_price_price_small'}>USDT</span></span>
                <span className={classNames({
            'item_price_change': true,
            [getDirection(Number(item.quotes.USD.percent_change_24h))]: true
        })}>{Number(item.quotes.USD.percent_change_24h).toFixed(2)}%</span>
            </div>
            {item.quotes.USD.percent_change_24h > 0 ?
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                    <path d="M6.67188 7.68741H21.4406V22.4561" stroke="#2ebd85" strokeWidth="2"/>
                    <path d="M21.7418 7.38264L7.38257 21.7419" stroke="#2ebd85" strokeWidth="2"/>
                </svg> : <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                    <path d="M21.4404 6.6718V21.4405H6.67171" stroke="#f6465d" strokeWidth="2"/>
                    <path d="M21.7452 21.7419L7.38599 7.38264" stroke="#f6465d" strokeWidth="2"/>
                </svg>}
        </div>
    </li>;
};
const MediaItem = ({ link }) => {
    return <li className={'currencies_links_link'}>
        <span>
            {link.title}
        </span>
    </li>;
};
const CoinList = ({ t }) => {
    const coin_list = t('coldware_wallet:coin_list', {}, { returnObjects: true });
    const [coinsData, setCoinsData] = useState([]);
    const [listItems, setListItems] = useState({});
    const tickers = {
        top: ["BTC", "XRP", "SOL", "ADA", "TRX", "BNB"],
        bottom: ["DOGE", "GALA", "SHIB", "PEPE", "LEO", "FLOKI"]
    };
    const getDirection = (value) => {
        if (value > 0) {
            return 'up';
        }
        else
            return 'down';
    };
    const getData = async () => {
        return await axios.get('/api/coin-list', {
            headers: {
                "Content-Type": "application/json"
            }
        });
    };
    useEffect(() => {
        let apiData = getData().then(data => {
            setCoinsData(data.data);
        }).catch((err) => {
            setCoinsData([]);
        });
    }, []);
    useEffect(() => {
        if (coinsData.length) {
            let top = [];
            let bottom = [];
            tickers.top.forEach(ticker => {
                let coin = coinsData.find(el => el.symbol === ticker);
                if (coin) {
                    top.push(coin);
                }
            });
            tickers.bottom.forEach(ticker => {
                let coin = coinsData.find(el => el.symbol === ticker);
                if (coin) {
                    bottom.push(coin);
                }
            });
            setListItems({
                top: top,
                bottom: bottom
            });
        }
    }, [coinsData]);
    return (<section className={'coin_list'}>
            <div className="container">
                <div className="currencies_wrapper">
                    <ul className={'currencies_links'}>
                        {coin_list.currencies.map((link, i) => {
            return <MediaItem key={link.title} i={i} link={link}/>;
        })}
                    </ul>
                    <p className={'currencies_description'}>{coin_list.description}</p>
                </div>
            </div>
            <div className="currencies">
                <div className={classNames({
            "items_loading": true,
            "loading": !listItems.top || !listItems.bottom
        })}>{coin_list.loading}...
                </div>
                <div className="items-wrap">
                    <div className="items marquee">
                        {listItems.top && listItems.top.map((item, index) => {
            return <CoinItem getDirection={getDirection} item={item} key={item.symbol} index={index + 1}/>;
        })}
                    </div>
                    <div aria-hidden="true" className="items marquee">
                        {listItems.top && listItems.top.map((item, index) => {
            return <CoinItem getDirection={getDirection} item={item} key={item.symbol} index={index + 1}/>;
        })}
                    </div>
                </div>
                <div className="items-wrap">
                    <div className="items marquee reverce">
                        {listItems.bottom && listItems.bottom.map((item, index) => {
            return <CoinItem getDirection={getDirection} item={item} key={item.symbol} index={index + 1}/>;
        })}
                    </div>
                    <div aria-hidden="true" className="items marquee reverce">
                        {listItems.bottom && listItems.bottom.map((item, index) => {
            return <CoinItem getDirection={getDirection} item={item} key={item.symbol} index={index + 1}/>;
        })}
                    </div>
                </div>
            </div>
        </section>);
};
export default CoinList;

    async function __Next_Translate__getStaticProps__196111dc4b1__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//ecosystem/wallet/CoinList/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__196111dc4b1__ as getStaticProps }
  